import gql from 'graphql-tag';

import { promocodeData } from 'core/api/apollo/fragments';

export const SIGN_IN = gql`
  mutation signIn($email: String!, $password: String!, $isAdmin: Boolean) {
    signIn(email: $email, password: $password, isAdmin: $isAdmin) {
      token
    }
  }
`;

export const SIGN_IN_WITH_TOKEN = gql`
  mutation signInWithToken($token: String!) {
    signInWithToken(token: $token) {
      token
    }
  }
`;

export const INIT_PAYMENT = gql`
  mutation InitPayment($input: InitSubInput!) {
    initPayment(input: $input) {
      status
      paymentUrl
    }
  }
`;

export const INIT_PAYMENT_SBP = gql`
  mutation InitPaymentSBP($input: InitSubInput!) {
    initPaymentSBP(input: $input) {
      status
      paymentUrl
    }
  }
`;

export const CANCEL_SUBSCRIPTION = gql`
  mutation CancelSubscription {
    cancelSubscription
  }
`;

export const CLEAR_SUBSCRIPTION = gql`
  mutation ClearSubscription {
    clearSubscription
  }
`;

export const ACTIVATE_PROMOCODE = gql`
  mutation ActivatePromocode($code: String!) {
    activatePromocode(code: $code) {
      status
      promocode {
        ...PromocodeData
      }
    }
  }
  ${promocodeData}
`;